import React, { useEffect, useState, useRef } from 'react';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    
    // Force video to play on mount
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log('Autoplay prevented:', error);
        // Try to play again after a short delay
        setTimeout(() => {
          if (videoRef.current) {
            videoRef.current.play();
          }
        }, 500);
      });
    }
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hero-section">
      <div className="hero-background">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="hero-video"
          style={{
            transform: `translateY(${scrollY * 0.3}px)`
          }}
        >
          <source 
            src="https://customer-assets.emergentagent.com/job_unknown-branding/artifacts/6olt07a8_elite-background-with-black-elements-reflection-2025-12-09-12-59-54-utc.mp4" 
            type="video/mp4" 
          />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay"></div>
        <div className="hero-grain"></div>
        <div className="hero-particle"></div>
        <div className="hero-particle"></div>
        <div className="hero-particle"></div>
        <div className="hero-particle"></div>
      </div>
      <div className="hero-content">
        <h1 className="hero-main-text">Contemporary Branding Solutions</h1>
      </div>
    </section>
  );
};

export default Hero;
